module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/a314b6745357bba80e03ea7e9856693e.svg";